import gql from 'graphql-tag';

export default gql`
  fragment publicDoorKeyFragment on PublicDoorKeyType {
    state
    guestName
    spaceName
    windows {
      unlockText
      useText
    }
  }
`;
